import { classNames } from "primereact/utils";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { Icon, IconType } from "../../../../common/icons/Icon";
import { MessageBanner } from "../../../../common/components/common/MessageBanner/MessageBanner";
import { useStripeConnectSection } from "../hooks/useStripeConnectSection";
import { NapSettingsSection } from "./NapSettingsSection";
import styles from "./StripeConnectSection.module.scss";

export const StripeConnectSection = () => {
  const {
    isConnected,
    maskedAccountId,
    isFetchingStatus,
    isFetchingUrl,
    isDisconnecting,
    handleConnect,
    handleDisconnect,
    refetchStatus,
  } = useStripeConnectSection();

  return (
    <div className={styles.root}>
      <MessageBanner
        type="info"
        width="100%"
        message="Тази Stripe връзка ще се използва за всички ваши обекти."
      />

      <MessageBanner
        type="info"
        width="100%"
        message="Платформена такса от 1.9% се начислява върху всяка покупка, платена чрез Stripe през системата."
      />

      <div
        className={classNames(styles.card, {
          [styles.card_connected]: isConnected,
        })}
      >
        <div className={styles.header}>
          <div className={styles.titleGroup}>
            <div className={styles.iconTile} aria-hidden="true">
              <Icon type={IconType.Stripe} width={22} height={22} />
            </div>
            <div className={styles.titleText}>
              <span className={styles.cardTitle}>Stripe Connect</span>
              <span className={styles.cardSubtitle}>
                {isConnected
                  ? "Плащанията ще постъпват в свързания акаунт"
                  : "Свържете акаунт, за да приемате плащания"}
              </span>
              {isConnected && maskedAccountId && (
                <span className={styles.accountId}>{maskedAccountId}</span>
              )}
            </div>
          </div>
          <StatusBadge
            isConnected={isConnected}
            isFetching={isFetchingStatus}
          />
        </div>

        {!isConnected && (
          <p className={styles.hint}>
            Свързването ще отвори нов таб — настройките в текущия таб няма да
            бъдат засегнати.
          </p>
        )}

        <div className={styles.actions}>
          {isConnected ? (
            <DefaultButton
              label="Откажи връзката"
              onClick={handleDisconnect}
              design="neutral"
              disabled={isDisconnecting}
              width="100%"
            />
          ) : (
            <DefaultButton
              label={isFetchingUrl ? "Зарежда..." : "Свържи със Stripe"}
              onClick={handleConnect}
              design="accent"
              disabled={isFetchingUrl}
              width="100%"
            />
          )}
          <DefaultButton
            label="Обнови"
            onClick={() => refetchStatus()}
            design="neutral"
            disabled={isFetchingStatus}
            width="100%"
          />
        </div>
      </div>

      {isConnected && <NapSettingsSection />}
    </div>
  );
};

const StatusBadge = ({
  isConnected,
  isFetching,
}: {
  isConnected: boolean;
  isFetching: boolean;
}) => {
  if (isFetching) {
    return (
      <span className={classNames(styles.badge, styles.badge_loading)}>
        <span className={styles.badge_dot} />
        Зарежда...
      </span>
    );
  }
  if (isConnected) {
    return (
      <span className={classNames(styles.badge, styles.badge_connected)}>
        <span className={styles.badge_dot} />
        Свързан
      </span>
    );
  }
  return (
    <span className={classNames(styles.badge, styles.badge_disconnected)}>
      <span className={styles.badge_dot} />
      Не е свързан
    </span>
  );
};
